// @flow

import React, { Component } from 'react';
import type { ComponentType } from 'react';

type Props = {
  breakpoint: 'sm' | 'md' | 'lg',
  prop: string,
};

export default ({ breakpoint, prop }: Props) => (
  (WrappedComponent: ComponentType<*>) => (
    class extends Component<*> {
      componentDidUpdate(prevProps: Props) {
        // eslint-disable-next-line react/destructuring-assignment
        if (document.body && prevProps[prop] !== this.props[prop]) {
          // eslint-disable-next-line react/destructuring-assignment
          if (this.props[prop]) {
            document.body.classList.add(`noscroll-${breakpoint}`);
          } else {
            document.body.classList.remove(`noscroll-${breakpoint}`);
          }
        }

        return null;
      }

      componentWillUnmount() {
        if (document.body) {
          document.body.classList.remove(`noscroll-${breakpoint}`);
        }
      }

      render() {
        return <WrappedComponent {...this.props} />;
      }
    }
  )
);
